import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

export function getLang () {
  let lang = getCookie('currentCulture');
  if (lang) {
    return lang;
  } else {
    if (navigator.languages !== undefined) {
      lang = navigator.languages[0];
    } else {
      lang = navigator.language;
    }
    lang = lang.split('-')[0];
    console.debug('language from browser', lang);
    return lang;
  }
}

function getCookie (name) {
  var value = '; ' + document.cookie;
  var parts = value.split('; ' + name + '=');
  if (parts.length === 2) return parts.pop().split(';').shift();
}


export const customTranslationsPlugin = (translations) => {
  return new VueI18n({
    locale: getLang(),
    fallbackLocale: 'nl',
    messages: translations
  });
};


export function loadLanguageAsync(i18n, lang) {
  if(lang === 'nl'){
    return;
  }
  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/resources/${lang}/resource.json`).then(
    messages => {
      i18n.setLocaleMessage(lang, messages.default);
      return setI18nLanguage(i18n, lang);
    }
  );
}

function setI18nLanguage (i18n, lang) {
  i18n.locale = lang;
  return lang;
}
